export const ADD_VALIDATOR = "addValidator";
export const ADD_ERROR = "addError";
export const REMOVE_ERROR = "removeError";
export const CLEAR_VALIDATOR = "clearValidator";
